<template>
  <consultation-media
    v-if="Object.keys(images).length > 0"
    class="col-md-12 px-0"
    :case-id="examination.id"
    :images="images"
    :product="examination.type.name"
    :data-image-metadata="imageMetadata"
    @update:images="images = $event"
  />
</template>

<script>
import ConsultationMedia from "../../AddOns/ConsultationMedia.vue";
import _find from "lodash/fp/find";
import _flow from "lodash/fp/flow";
import _get from "lodash/fp/get";
import _keyBy from "lodash/fp/keyBy";

export default {
  components: {
    ConsultationMedia,
  },
  /**
   * @see https://vuejs.org/guide/components/attrs.html#nested-component-inheritance
   * Since this component receives all props from the parent component, we need to disable
   * inheritance here since this will override certain props that we pass here to
   * the consultation-images component. (e.g. product)
   */
  inheritAttrs: false,
  props: {
    fields: Array,
    examination: Object,
  },
  data() {
    return {
      images: {},
    };
  },
  computed: {
    imageMetadata() {
      return _flow(
        _find({ type: "external_result" }),
        _get("metadata.images"),
      )(this.examination?.study_results);
    },
  },
  mounted: function () {
    this.mapImages();
  },
  methods: {
    mapImages: function () {
      this.images = Object.values(this.examination.images).filter(
        (image) => image.show_in_gallery === true,
      );
    },
  },
};
</script>
